<template>
  <div class="side-menu-left menu-test">123456</div>
</template>

<script>
import store from '../../store'

export default {
  data () {
    return {
      currentYear: new Date().getFullYear(),
      isDowngradeUser: store.getters.currentUser ? store.getters.currentUser.role_id === 1 : false
    }
  },
  methods: {
    // here is the code
    isActiveRoute (routes) {
      if (!Array.isArray(routes)) {
        return false
      }
      return routes.some(route => this.$route.path === route)
    },
    openIconDropDown (event) {
      // document.body.classList.toggle('left-menu-open')
      const currentMenuWrapper = event.currentTarget.closest('.menu-list-wrapper')
      const allMenuWrappers = document.querySelectorAll('.menu-list-wrapper')
      allMenuWrappers.forEach(wrapper => {
        if (wrapper !== currentMenuWrapper) {
          wrapper.classList.remove('menu-dropdown')
        }
      })
      currentMenuWrapper.classList.toggle('menu-dropdown')
      document.body.classList.add('left-menu-open')
    },
    toggleMenu () {
      document.body.classList.toggle('left-menu-open')
      this.closeAllDropdowns()
    },
    closeMenu () {
      // console.log('ffffffffff')
      document.body.classList.remove('left-menu-open')
      this.closeAllDropdowns()
    },
    goToDashboard () {
      this.$router.push('/')
    },
    toggleDropdown (event) {
      const currentMenuWrapper = event.currentTarget.closest('.menu-list-wrapper')
      const allMenuWrappers = document.querySelectorAll('.menu-list-wrapper')
      allMenuWrappers.forEach(wrapper => {
        if (wrapper !== currentMenuWrapper) {
          wrapper.classList.remove('menu-dropdown')
        }
      })
      currentMenuWrapper.classList.toggle('menu-dropdown')
    },
    closeAllDropdowns () {
      const menuWrappers = document.querySelectorAll('.menu-list-wrapper')
      menuWrappers.forEach(wrapper => {
        wrapper.classList.remove('menu-dropdown')
      })
    }
  },
  props: ['userRole', 'partner_level', 'user', 'isHivePartner', 'companyName', 'totalImpacts']
}
</script>



// WEBPACK FOOTER //
// src/components/business/menu-custom.vue